export default "__VITE_PUBLIC_ASSET__d25f9222__"